import { object, string, boolean } from "yup";

import "./schemas";

const providerSchema = object({
  name: string()
    .trim()
    .required()
    .matches(/^[a-zA-Z0-9 ]*$/, "Only alphanumerics with spaces are allowed."),
  type: string()
    .trim()
    .required()
    .matches(/^[a-zA-Z0-9 ]*$/, "Only alphanumerics with spaces are allowed."),
  emailAddress: string()
    .required()
    .email("Invalid email address"),
  active: boolean()
});

export default providerSchema;
